export default class City {
  public static readonly SET_LIST = "COMPANY_CITY_SET_LIST";
  public static readonly SET_STATUS = "COMPANY_CITY_SET_STATUS";
  public static readonly SET_ERROR = "COMPANY_CITY_SET_ERROR";
  public static readonly CLEAR = "COMPANY_CITY_CLEAR";

  public static setList(data: any) {
    return {
      data,
      type: City.SET_LIST,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: City.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: City.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: City.CLEAR,
    };
  }
}